/**
 * Runtime config error formatting + save-payload helpers.
 *
 * Extracted from RuntimeConfigDialog to keep it under the 200-line
 * component cap — these are pure functions with no JSX/hook dependencies.
 */

import { isAxiosError } from 'axios';
import type { RuntimeConfigEntry } from '../schemas/admin.schemas';

function extractErrorDetail(error: unknown): string | null {
  if (!isAxiosError(error)) return null;
  const data: unknown = error.response?.data;
  if (data && typeof data === 'object' && 'detail' in data) {
    const detail = (data as { detail: unknown }).detail;
    if (typeof detail === 'string') return detail;
  }
  return null;
}

function describeEntry(kind: 'file' | 'env', name: string): string {
  return kind === 'file' ? `file "${name}"` : `env var "${name}"`;
}

/** Names the failing entry (kind + name) so the dialog-level error banner
 * attributes the failure to a specific row/form instead of a bare message. */
export function formatMutationError(
  action: 'save' | 'delete',
  kind: 'file' | 'env',
  name: string,
  error: unknown,
): string {
  const detail = extractErrorDetail(error);
  return `Failed to ${action} ${describeEntry(kind, name)}${detail ? `: ${detail}` : '.'}`;
}

export function buildSavePayload(
  entry: RuntimeConfigEntry,
  value: string,
): { value: string; target_path?: string; file_mode?: string; secret?: boolean } {
  if (entry.kind === 'file') {
    return {
      value,
      ...(entry.target_path ? { target_path: entry.target_path } : {}),
      ...(entry.file_mode ? { file_mode: entry.file_mode } : {}),
    };
  }
  return { value, secret: entry.secret };
}
